module.exports = __webpack_public_path__ + "static/media/goodnest_job1_preview.eed4e5d7.jpg";